module.exports = __webpack_public_path__ + "static/media/dapp-card.99305ef0.svg";